export const AGE_GATE_BLOCK_UNDER = 13;

export const AGE_GATE_THRESHOLDS = {
  threshold1: 13,
  threshold2: 16,
} as const;

export const AGE_GATE_DECISION_TIMEOUT_MS = 9000;
